// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Patient dashboard
 */

.patientDashboard_page__U2KWL {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: var(--space-6) var(--gutter) var(--space-16);
  box-sizing: border-box;
}

.patientDashboard_header__Lx10n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-4);
}

.patientDashboard_headerText__CQtJR {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.patientDashboard_title__zlFLJ {
  font-size: clamp(1.4rem, 1.16rem + 0.75vw, 1.8rem);
  font-weight: 700;
  line-height: 1.18;
  letter-spacing: -0.022em;
  color: var(--text-primary);
}

.patientDashboard_subtitle__8DIMV {
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
  max-width: 62ch;
}

/* Range picker */
.patientDashboard_rangeControl__irdCO {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex: none;
}

.patientDashboard_rangeLabel__dYVta {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}

select.patientDashboard_rangeSelect__bwzzr {
  width: auto;
  min-width: 130px;
}

/* Panel contents */
div.patientDashboard_panel__DVNhH {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.patientDashboard_note__jIhD7 {
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

.patientDashboard_ctaRow__fTxlT {
  display: flex;
  justify-content: flex-end;
}

.patientDashboard_count__Acvaj {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.patientDashboard_pagination__Nsuna {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-3);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border-light);
}

.patientDashboard_pageBtns__-u-uh {
  display: flex;
  gap: var(--space-2);
}

.patientDashboard_footerRow__th\\+ED {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 560px) {
  .patientDashboard_page__U2KWL {
    gap: var(--space-4);
    padding: var(--space-4) var(--gutter) var(--space-8);
  }

  .patientDashboard_subtitle__8DIMV,
  .patientDashboard_note__jIhD7 {
    font-size: 0.875rem;
  }

  div.patientDashboard_panel__DVNhH {
    gap: var(--space-4);
  }

  .patientDashboard_rangeControl__irdCO {
    width: 100%;
  }

  .patientDashboard_rangeSelect__bwzzr {
    flex: 1 1;
  }

  .patientDashboard_ctaRow__fTxlT > * {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/patientDashboard.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;IACnB,oDAAoD;EACtD;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/*\n * Patient dashboard\n */\n\n.page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: var(--space-6) var(--gutter) var(--space-16);\n  box-sizing: border-box;\n}\n\n.header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n}\n\n.headerText {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 0;\n}\n\n.title {\n  font-size: clamp(1.4rem, 1.16rem + 0.75vw, 1.8rem);\n  font-weight: 700;\n  line-height: 1.18;\n  letter-spacing: -0.022em;\n  color: var(--text-primary);\n}\n\n.subtitle {\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n  max-width: 62ch;\n}\n\n/* Range picker */\n.rangeControl {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  flex: none;\n}\n\n.rangeLabel {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\nselect.rangeSelect {\n  width: auto;\n  min-width: 130px;\n}\n\n/* Panel contents */\ndiv.panel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n\n.note {\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.ctaRow {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.count {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border-light);\n}\n\n.pageBtns {\n  display: flex;\n  gap: var(--space-2);\n}\n\n.footerRow {\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 560px) {\n  .page {\n    gap: var(--space-4);\n    padding: var(--space-4) var(--gutter) var(--space-8);\n  }\n\n  .subtitle,\n  .note {\n    font-size: 0.875rem;\n  }\n\n  div.panel {\n    gap: var(--space-4);\n  }\n\n  .rangeControl {\n    width: 100%;\n  }\n\n  .rangeSelect {\n    flex: 1;\n  }\n\n  .ctaRow > * {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `patientDashboard_page__U2KWL`,
	"header": `patientDashboard_header__Lx10n`,
	"headerText": `patientDashboard_headerText__CQtJR`,
	"title": `patientDashboard_title__zlFLJ`,
	"subtitle": `patientDashboard_subtitle__8DIMV`,
	"rangeControl": `patientDashboard_rangeControl__irdCO`,
	"rangeLabel": `patientDashboard_rangeLabel__dYVta`,
	"rangeSelect": `patientDashboard_rangeSelect__bwzzr`,
	"panel": `patientDashboard_panel__DVNhH`,
	"note": `patientDashboard_note__jIhD7`,
	"ctaRow": `patientDashboard_ctaRow__fTxlT`,
	"count": `patientDashboard_count__Acvaj`,
	"pagination": `patientDashboard_pagination__Nsuna`,
	"pageBtns": `patientDashboard_pageBtns__-u-uh`,
	"footerRow": `patientDashboard_footerRow__th+ED`
};
export default ___CSS_LOADER_EXPORT___;
